import RootState from '../../state';
import { ThunkDispatch } from 'redux-thunk';
import {
    setRestructuredDirectoryContactsByPhoneNumberLoading,
    setRestructuredDirectoryContactsByPhoneNumber,
    IRestructuredContactsByPhoneNumberActions,
} from './actions';
import { formatPhoneNumber, isNilOrEmpty } from 'utils';
import { IDirectoryRecord } from '../directory.state';
import PhoneLib from 'google-libphonenumber';

export const getRestructuredDirectoryContactsByPhoneNumber = (
    directoryContacts: IDirectoryRecord[]
) => async (
    dispatch: ThunkDispatch<
        RootState,
        undefined,
        IRestructuredContactsByPhoneNumberActions
    >
) => {
    dispatch(setRestructuredDirectoryContactsByPhoneNumberLoading(true));

    const contactsWithPhoneNumbers = directoryContacts.filter((contact) => {
        return !isNilOrEmpty(contact.phoneNumbers);
    });

    const restructuredContacts = contactsWithPhoneNumbers.reduce(
        (acc, contact) => {
            contact.phoneNumbers!.forEach((phone) => {
                if (phone.value) {
                    const formattedPhoneNumber = formatPhoneNumber(
                        phone.value,
                        PhoneLib.PhoneNumberFormat.E164
                    );

                    acc[formattedPhoneNumber] = contact;
                }
            });

            return acc;
        },
        {} as Record<string, IDirectoryRecord>
    );

    dispatch(
        setRestructuredDirectoryContactsByPhoneNumber(restructuredContacts)
    );

    dispatch(setRestructuredDirectoryContactsByPhoneNumberLoading(false));
};
